import { Log, WebStorageStateStore } from 'oidc-client-ts';
import logger from '../../utils/logger';

// Enable OIDC logging in non-production environments
// eslint-disable-next-line no-underscore-dangle
if ((window.__ENV || {}).REACT_APP_OIDC_DEBUG === 'true') {
  // Route OIDC library logs through our centralized logger
  Log.setLogger(logger);
  Log.setLevel(Log.DEBUG);
  logger.info('OIDC debug mode enabled');
}
// eslint-disable-next-line no-underscore-dangle
const scope = (window.__ENV || {}).REACT_APP_OAUTH_SCOPE || '';

const customUserStore = new WebStorageStateStore({
  store: {
    getItem: () => null,
    setItem: () => null,
    removeItem: () => null,
  },
});

const customStateStore = new WebStorageStateStore({ 
  prefix: 'become.', 
  store: window.sessionStorage 
});

// Configuration for @axa-fr/react-oidc
export const oidcConfiguration = {
  // eslint-disable-next-line no-underscore-dangle
  authority: (window.__ENV || {}).REACT_APP_OAUTH_AUTHORITY,
  // eslint-disable-next-line no-underscore-dangle
  client_id: (window.__ENV || {}).REACT_APP_OAUTH_CLIENT_ID,
  // eslint-disable-next-line no-underscore-dangle
  redirect_uri: (window.__ENV || {}).REACT_APP_OAUTH_REDIRECT_URI,
  // eslint-disable-next-line no-underscore-dangle
  silent_redirect_uri: (window.__ENV || {}).REACT_APP_OAUTH_SILENT_RENEW_URI,
  // eslint-disable-next-line no-underscore-dangle
  post_logout_redirect_uri: (window.__ENV || {}).REACT_APP_LOGOUT_URL,
  response_type: 'code',
  scope: scope,
  
  // Token handling settings
  filterProtocolClaims: true,
  automaticSilentRenew: true,
  revokeAccessTokenOnSignout: true,
  loadUserInfo: true,
  userStore: customUserStore,
  stateStore: customStateStore,
  monitorSession: false,
  clockSkew: 1200, // 20 minutes tolerance
  accessTokenExpiringNotificationTime: 300,
  staleStateAge: 300,
};

export const callbackSettings = {
  callbackPath: '/authdepot/callback',
  silentCallbackPath: '/oidc/callback',
  successCallback: (user, navigate) => {
    // Get the return URL from user state or session storage
    const returnPath = (user.state || {}).redirectUrl || 
      sessionStorage.getItem('returnUrl') || '/admissions';
    navigate(returnPath);
  },
  errorCallback: (error, handleCallbackError) => {
    if (handleCallbackError) handleCallbackError(error);
  }
};
// Export the OIDCConfig object for more complex usages
export default oidcConfiguration;
